
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.slh-action-button-item {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-style: normal;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  text-transform: uppercase;
  color: var(--slh-color-neutral-shade-60, #62779F);
  padding: 8px 0 8px 0;
  display: block;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
}
.slh-action-button-item:hover {
  color: var(--slh-color-neutral-shade-60, #62779F);
}
.slh-action-button-item:focus {
  outline: none;
}

*:focus {
  outline: none;
}

.slh-action-button-item {
  text-transform: none;
}

:host(:focus-visible) {
  outline: none;
}
:host(:focus-visible) span {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  outline: none;
}
:host(:focus-visible) span::after {
  content: "";
  display: block;
  width: calc(100% - 24px);
  height: 40px;
  position: absolute;
  margin-top: -30px;
  margin-left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 8px;
}
`;
